/* Court Vibes, 27.10.2026. Ersatzbild im Warenkorb, wenn teeinblue keins
   liefert.

   Gemessen am 27.10.2026, nicht vermutet:
   Auf jeder personalisierten Seite ersetzt teeinblues Warenkorb-Skript das
   Shopify-Produktbild durch ein <div class="tee-cart-thumbnail"> und laedt
   dort das personalisierte Bild aus der Artikel-Eigenschaft
   _customization_image. Beim Kinder-Hoodie (Kampagne mit Product Base)
   existiert dieses Bild sofort, 960x960. Bei der Tennis Mama Tasse
   (Kampagne ueber bestehendes Shopify-Produkt, Snapwear) legt teeinblue
   die Eigenschaft zwar an, erzeugt das Bild aber nie, auch nicht ueber
   seinen eigenen Knopf im Vorschau-Popup, auch nicht nach 90 Sekunden.
   Der Platzhalter bleibt dann leer, nur ein Ladekreis.

   Wie teeinblue vorgeht, in vier Versuchen gemessen am 27.10.2026:
   1. Ein Bild IM Platzhalter: fliegt nach rund 600 ms wieder raus,
      teeinblue schreibt den Platzhalter alle drei Sekunden neu.
   2. Ein eigenes <a> mit <img> neben dem teeinblue-Link: wird von
      teeinblue uebernommen und entleert.
   3. Ein eigenes <div> mit <img>, egal ob erstes oder letztes Kind der
      Zelle: ebenfalls uebernommen und entleert. teeinblue sucht also
      JEDES <img> in der Warenkorbzeile und ersetzt dessen Elternelement.
   4. Ein <div> mit CSS-Hintergrundbild, ohne <img>: bleibt stehen.
   Deshalb ist das Ersatzbild ein <div> mit background-image.

   Fuenfter Befund: auf der Produktseite (Warenkorb-Schubfach) laufen
   dauernd DOM-Aenderungen, teeinblue allein baut seine Platzhalter alle
   paar hundert Millisekunden neu. Eine Entprellung, die bei jeder Aenderung
   neu startet, kam dort NIE zum Zug, auf /cart dagegen schon. Deshalb
   jetzt eine Drossel: hoechstens alle 300 ms, aber garantiert.

   Das Ersatzbild ist das Shopify-Produktbild des Artikels, geholt ueber
   /cart.js und ueber die customization_id aus der Platzhalter-ID dem
   Artikel zugeordnet. Es kommt in die Tabellenzelle (td.cart-items__media)
   neben den teeinblue-Link, der per Klasse an der Zelle ausgeblendet wird.
   Liefert teeinblue doch noch ein eigenes Bild (img im Platzhalter), wird
   das Ersatzbild wieder entfernt.

   Damit das Ersatzbild etwas zeigt, muss das Shopify-Produkt ein echtes
   Bild haben (Mockup mit Motiv), nicht nur die leere Tasse.

   Pruefen: window.CV_WARENKORB_BILD muss true sein. */

(function () {
  var WARTEZEIT = 2500;
  var TAKT = 300;
  var KLASSE_AKTIV = 'cv-ersatz-aktiv';
  var cartCache = null;
  var cartZeit = 0;
  var stilGesetzt = false;

  function stil() {
    if (stilGesetzt) return;
    stilGesetzt = true;
    var s = document.createElement('style');
    s.textContent =
      '.' + KLASSE_AKTIV + ' > :not(.cv-ersatz-bild){display:none !important;}' +
      '.cv-ersatz-bild{display:block;width:100%;aspect-ratio:1/1;max-height:100%;' +
      'background-position:center;background-size:cover;background-repeat:no-repeat;' +
      'border-radius:inherit;cursor:pointer;}';
    document.head.appendChild(s);
  }

  function cartHolen() {
    var jetzt = Date.now();
    if (cartCache && jetzt - cartZeit < 3000) return Promise.resolve(cartCache);
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartCache = c; cartZeit = Date.now(); return c; });
  }

  function idAus(el) {
    var m = String(el.id || '').match(/tee-cart-thumbnail-(.+)$/);
    return m ? m[1] : null;
  }

  function aussen(el) {
    var a = el;
    while (a.parentElement && a.parentElement.classList.contains('tee-cart-thumbnail')) a = a.parentElement;
    return a;
  }

  function artikelZu(cart, cid) {
    for (var i = 0; i < cart.items.length; i++) {
      var p = cart.items[i].properties || {};
      if (p._customization_id === cid) return cart.items[i];
    }
    return null;
  }

  function pruefen() {
    var zellen = [];
    Array.prototype.slice.call(document.querySelectorAll('.tee-cart-thumbnail')).forEach(function (el) {
      var link = aussen(el).parentElement;
      var zelle = link && link.parentElement;
      if (!zelle || zellen.indexOf(zelle) > -1) return;
      zellen.push(zelle);
    });

    zellen.forEach(function (zelle) {
      var teeBild = zelle.querySelector('.tee-cart-thumbnail img');
      var ersatz = zelle.querySelector(':scope > .cv-ersatz-bild');

      if (teeBild) {
        if (ersatz) ersatz.remove();
        zelle.classList.remove(KLASSE_AKTIV);
        delete zelle.dataset.cvGeplant;
        return;
      }
      if (ersatz || zelle.dataset.cvGeplant) return;

      zelle.dataset.cvGeplant = '1';
      var platz = zelle.querySelector('.tee-cart-thumbnail');
      var cid = platz ? idAus(platz) : null;
      setTimeout(function () {
        if (!zelle.isConnected) return;
        if (zelle.querySelector('.tee-cart-thumbnail img')) { delete zelle.dataset.cvGeplant; return; }
        cartHolen().then(function (cart) {
          var item = cid ? artikelZu(cart, cid) : null;
          if (!item || !item.image) { delete zelle.dataset.cvGeplant; return; }
          if (zelle.querySelector(':scope > .cv-ersatz-bild')) return;
          stil();
          var box = document.createElement('div');
          box.className = 'cv-ersatz-bild';
          box.setAttribute('role', 'link');
          box.setAttribute('aria-label', item.product_title || '');
          box.style.backgroundImage = 'url("' + item.image + '")';
          if (item.url) {
            box.addEventListener('click', function () { window.location.href = item.url; });
          }
          zelle.appendChild(box);
          zelle.classList.add(KLASSE_AKTIV);
        }).catch(function () { delete zelle.dataset.cvGeplant; });
      }, WARTEZEIT);
    });
  }

  /* Drossel statt Entprellung, siehe fuenfter Befund oben. */
  var geplant = false;
  function angestossen() {
    if (geplant) return;
    geplant = true;
    setTimeout(function () {
      geplant = false;
      try { pruefen(); } catch (e) {}
    }, TAKT);
  }

  function start() {
    try { pruefen(); } catch (e) {}
    new MutationObserver(angestossen).observe(document.body, { childList: true, subtree: true });
    window.CV_WARENKORB_BILD = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
